document.addEventListener('DOMContentLoaded', () => {

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        imagesSliders.forEach((item)=>{
            new Swiper(item, {
                rewind: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".pagination-images",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                },
            });
        });
    }

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        swiperTop.forEach((item)=>{
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".pagination-hero",
                    clickable: true,
                }
            });
        });
    }

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((item)=> {
            new Swiper(item, {
                loop: false,
                effect: "slide",
                slidesPerView: "auto",
                spaceBetween: 50,
                rewind: true,
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-gal-next",
                    prevEl: ".sw-gal-prev",
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    600: {
                        effect: "fade",
                        spaceBetween: 0,
                    }
                }
            });
        });
    }

    let slideSlider = document.querySelectorAll('.slide-slider');
    if(slideSlider){
        slideSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                autoHeight: true,
                uniqueNavElements: false,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-m-but-next",
                    prevEl: ".sw-m-but-prev",
                },
                breakpoints: {
                    1030: {
                        autoHeight: false,
                        navigation: {
                            nextEl: ".sw-s-but-next",
                            prevEl: ".sw-s-but-prev",
                        },
                    }
                }
            });
        });
    }

    let reviewsSlider = document.querySelectorAll('.reviews-slider');
    if(reviewsSlider){
        reviewsSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-rev-next",
                    prevEl: ".sw-rev-prev",
                },
                breakpoints: {
                    1030: {
                        autoHeight: false,
                    }
                }
            });
        });
    }

    let cardSlider = document.querySelectorAll('.card-slider');
    if(cardSlider){
        cardSlider.forEach((item)=> {
            new Swiper(item, {
                loop: false,
                effect: "fade",
                speed: 1000,
                slidesPerView: 1,
                spaceBetween: 30,
                allowTouchMove: true,
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    800: {
                        effect: "slide",
                        slidesPerView: 2,
                        spaceBetween: 140,
                        allowTouchMove: false,
                    },
                    600: {
                        spaceBetween: 50,
                    }
                }
            });
        });
    }

});